import IdentitasMurid from "../../../../../components/categories/siakad/laporan_adab/identitas_murid/Home";
export default function Home() {
  
  return (
    <IdentitasMurid />
  );
}
